import { render, staticRenderFns } from "./MediaDevicesSelector.vue?vue&type=template&id=2297b2aa&scoped=true&"
import script from "./MediaDevicesSelector.vue?vue&type=script&lang=js&"
export * from "./MediaDevicesSelector.vue?vue&type=script&lang=js&"
import style0 from "./MediaDevicesSelector.vue?vue&type=style&index=0&id=2297b2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297b2aa",
  null
  
)

export default component.exports